export default {"src":"/_next/static/media/pendingRequest.01a61d2a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};